<template>
    <div class="detailItem">
        <div class="detailTitle">
            <h4>{{title}}</h4>
        </div>
        <div class="detailContent">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "taskDetailComItem",
        props:{title:{type:String, required:true}}
    }
</script>

<style scoped lang="scss">
    $bgColorWhite: #fff;
    $borderColor: #0755a2;
    .detailItem{
        .detailTitle{
            background-color: $bgColorWhite;
            width: 100%;
            line-height: 50px;
            border-bottom: 1px solid $borderColor;
            > h4{
                margin-left: 30px;
                letter-spacing: 2px;
                font-weight: 500;
                font-size: 16px;
            }
    }
    .detailContent {
        background-color: $bgColorWhite;
        width: 98%;
        height: auto;
        margin: 10px auto;
        border-radius: 3px;
    }
}
</style>